import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import Error from "../../../Components/Common/Error";
import Loader from "../../../Components/Common/Loader";
import UploadCCFModal from '../../../Components/ManageCCFPoints/UploadCCFModal';
import UploadMappedCCF from '../../../Components/ManageCCFPoints/UploadMappedCCF';
import BasicTable from '../../../Components/ReactTable/BasicTable';
import { getCCFPoints } from '../../../slices/ManageCCFPoints/thunk';
import Swal from 'sweetalert2';
import { deleteCCFPointsAPI } from '../../../apiConfig/apiCall';

export default function ManageCCFPoints() {

    const [filtering, setFiltering] = useState('');
    const [pageSize, setPageSize] = useState(10);

    const dispatch = useDispatch();
    const { isLoading, isError, data } = useSelector(state => state.GetCCFPointList);

    const [uploadCertificateModal, setUploadCertificateModal] = useState(false);
    const toggleUploadCertificateModal = () => setUploadCertificateModal(!uploadCertificateModal);

    const [uploadMappedCCFModal, setUploadMappedCCFModal] = useState(false);
    const toggleUploadMappedCCFModal = () => setUploadMappedCCFModal(!uploadMappedCCFModal);

    const columns = [
        {
            header: "S.No",
            accessorKey: "id",
            cell: ({ row }) => (
                <span className="fw-semibold">{row.index + 1}</span>
            ),
            enableSorting: false,
        },
        {
            header: "Domain Title",
            accessorKey: "domainTitle",
        },
        {
            header: "Control Title",
            accessorKey: "controlTitle",
        },
        {
            header: "Control Reference",
            accessorKey: "controlReference",
        },
        {
            header: "Control Type",
            accessorKey: "controlType",
        },
        {
            header: "Status",
            accessorKey: "status",
            cell: ({ row }) => {
                const status = row.original.status;
                const statusColor = status === 'ACTIVE' ? 'green' : 'red';
                return (
                    <span style={{ color: statusColor }}>
                        {status}
                    </span>
                );
            },
        },
        {
            header: "Entry Date",
            accessorKey: "entryDate",
        },
        {
            header: "Actions",
            accessorKey: "actions",
            cell: ({ row }) => (
                <div className="d-flex gap-2">
                    <Link to={`/edit-cff-point/${row.original.id}`} className="text-primary fs-5 cursor-pointer">
                        <i className='bx bxs-edit'></i>
                    </Link>
                    <div onClick={() => handleDelete(row.original.id)} className="text-danger fs-5 cursor-pointer">
                        <i className='bx bxs-trash-alt'></i>
                    </div>
                </div>
            ),
            enableSorting: false,
        },
    ];

    const handleDelete = (id) => {
        Swal.fire({
            width: '20rem',
            padding: '0 0 1rem 0',
            title: "Are you sure?",
            text: `You won't be able to revert this!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteCCFPointsAPI(id)
                    .then(response => {
                        Swal.fire({
                            title: "Deleted!",
                            text: response.data,
                            icon: "success",
                            width: '20rem',
                            padding: '0 0 1rem 0',
                        });
                        dispatch(getCCFPoints());
                    })
                    .catch(error => {
                        Swal.fire({
                            title: "Error!",
                            text: error,
                            icon: "error",
                            width: '20rem',
                            padding: '0 0 1rem 0',
                        });
                    });
            }
        });
    };

    useEffect(() => {
        dispatch(getCCFPoints());
    }, [dispatch, pageSize]);

    if (isLoading) return <Loader />
    if (isError) return <Error />

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={'Manage CCF Points'} pageTitle={"Dashboard"} />

                    <Row>
                        <Col lg={12}>

                            <Card>
                                {/* <CardHeader className="border-0 py-1">
                                    <div className="d-flex">
                                        <div className="d-flex align-items-center">
                                            <h5 className="card-title mb-0">CCF Points List</h5>
                                            <ButtonGroup className="material-shadow ms-2">
                                                <UncontrolledDropdown>
                                                    <DropdownToggle
                                                        tag="button"
                                                        className="btn p-1 btn-sm btn-light material-shadow-none"
                                                        style={{
                                                            fontSize: '.7rem',
                                                        }}
                                                    >
                                                        {pageSize} <i className="mdi mdi-chevron-down"></i>
                                                    </DropdownToggle>
                                                    <DropdownMenu style={{ minWidth: '100%' }}>
                                                        {[10, 20, 50, 100].map((size) => (
                                                            <DropdownItem
                                                                key={size}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '0.2rem',
                                                                    fontSize: '.7rem',
                                                                }}
                                                                onClick={() => setPageSize(size)}
                                                            >
                                                                {size}
                                                            </DropdownItem>
                                                        ))}
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </ButtonGroup>
                                        </div>
                                        <div className="d-flex">
                                            <input
                                                className="form-control me-2"
                                                type="text"
                                                placeholder="Search..."
                                                value={filtering}
                                                onChange={(e) => setFiltering(e.target.value)}
                                                style={{
                                                    height: '28px',
                                                    fontSize: '.7rem',
                                                    borderRadius: '.2rem',
                                                }}
                                            />
                                            <Link
                                                to={'/add-ccf-point'}
                                                type="button"
                                                className="btn btn-sm btn-success me-2"
                                                style={{
                                                    width: '100%',
                                                    fontSize: '.7rem',
                                                    borderRadius: '.2rem',
                                                }}
                                            >
                                                <i className="ri-add-line align-bottom me-2"></i>
                                                Add CCF
                                            </Link>
                                            <Button
                                                type="button"
                                                className="btn-sm btn-success me-2"
                                                onClick={toggleUploadCertificateModal}
                                                style={{
                                                    width: '100%',
                                                    fontSize: '.7rem',
                                                    borderRadius: '.2rem',
                                                }}
                                            >
                                                <i className="ri-upload-line me-2"></i>
                                                Upload CCF
                                            </Button>
                                            <Button
                                                type="button"
                                                className="btn-sm btn-success"
                                                onClick={toggleUploadMappedCCFModal}
                                                style={{
                                                    width: '100%',
                                                    fontSize: '.7rem',
                                                    borderRadius: '.2rem',
                                                }}
                                            >
                                                <i className="ri-upload-line"></i>
                                                Upload Mapped CCF
                                            </Button>
                                        </div>
                                    </div>
                                </CardHeader> */}

                                <CardHeader className="border-0 py-1">

                                    <Row>

                                        <Col lg={5}>
                                            <div className="d-flex align-items-center">
                                                <h5 className="card-title mb-0 me-3">CCF Points List</h5>
                                                <ButtonGroup className="material-shadow">
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle
                                                            tag="button"
                                                            className="btn p-1 btn-sm btn-light material-shadow-none"
                                                            style={{
                                                                fontSize: '.7rem',
                                                            }}
                                                        >
                                                            {pageSize} <i className="mdi mdi-chevron-down"></i>
                                                        </DropdownToggle>
                                                        <DropdownMenu style={{ minWidth: '100%' }}>
                                                            {[10, 20, 50, 100].map((size) => (
                                                                <DropdownItem
                                                                    key={size}
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        padding: '0.2rem',
                                                                        fontSize: '.7rem',
                                                                    }}
                                                                    onClick={() => setPageSize(size)}
                                                                >
                                                                    {size}
                                                                </DropdownItem>
                                                            ))}
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </ButtonGroup>
                                            </div>
                                        </Col>

                                        <Col lg={7}>
                                            <Row>
                                                <Col lg={3} className='pe-1 ps-1'>
                                                    <input className="form-control me-2"
                                                        type="text"
                                                        placeholder="Search..."
                                                        value={filtering}
                                                        onChange={(e) => setFiltering(e.target.value)}
                                                        style={{
                                                            height: '28px',
                                                            fontSize: '.7rem',
                                                            borderRadius: '.2rem',
                                                        }}
                                                    />
                                                </Col>
                                                <Col lg={2} className='pe-1 ps-1'>
                                                    <Link
                                                        to={'/add-ccf-point'}
                                                        type="button"
                                                        className="btn btn-sm btn-success me-2"
                                                        style={{
                                                            fontSize: '.7rem',
                                                            borderRadius: '.2rem',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <i className="ri-add-line align-bottom me-2"></i>
                                                        Add CCF
                                                    </Link>
                                                </Col>
                                                <Col lg={3} className='pe-1 ps-1'>
                                                    <Button
                                                        type="button"
                                                        className="btn-sm btn-success me-2"
                                                        onClick={toggleUploadCertificateModal}
                                                        style={{
                                                            fontSize: '.7rem',
                                                            borderRadius: '.2rem',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <i className="ri-upload-line me-2"></i>
                                                        Upload CCF
                                                    </Button>
                                                </Col>
                                                <Col lg={4} className='pe-1 ps-1'>
                                                    <Button
                                                        type="button"
                                                        className="btn-sm btn-success"
                                                        onClick={toggleUploadMappedCCFModal}
                                                        style={{
                                                            fontSize: '.7rem',
                                                            borderRadius: '.2rem',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <i className="ri-upload-line me-2"></i>
                                                        Upload Mapped CCF
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>

                                    </Row>

                                </CardHeader>



                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <BasicTable
                                        columns={columns}
                                        data={data}
                                        customPageSize={pageSize}
                                        filtering={filtering}
                                        setFiltering={setFiltering}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <UploadCCFModal
                        uploadCertificateModal={uploadCertificateModal}
                        setUploadCertificateModal={setUploadCertificateModal}
                        toggleUploadCertificateModal={toggleUploadCertificateModal}
                    />

                    <UploadMappedCCF
                        uploadMappedCCFModal={uploadMappedCCFModal}
                        setUploadMappedCCFModal={setUploadMappedCCFModal}
                        toggleUploadMappedCCFModal={toggleUploadMappedCCFModal}
                    />

                </Container>
            </div>
        </>
    )
}
